export default "__VITE_ASSET__Cpm02w$j__"